// Maps a server-provided (permalinkType, permalinkId) pair to a
// canonical public URL path. Returns null for unknown types or
// missing ids so callers can degrade to plain text.
//
// Known types, sourced from the server (currently the /content-flags
// handler): 'story' | 'quiz' | 'group' | 'user' | 'admin_wall_post' |
// 'admin_wall_comment'. Message-type flag rows have no public
// permalink and arrive with permalinkType=null.
//
// The optional third arg `contentId` is the underlying flagged
// row's id (e.g. the comment id when type='story'); when provided,
// an in-page anchor is appended so admins land near the flagged
// item. Destination-side anchor support is best-effort.
export function contentPermalink(type, id, contentId) {
  if (!type || !id) return null
  switch (type) {
    case 'story':
      return contentId ? `/story/${id}#comment-${contentId}` : `/story/${id}`
    case 'quiz':
      return contentId ? `/quiz/${id}#comment-${contentId}` : `/quiz/${id}`
    case 'group':
      return contentId ? `/community/${id}#post-${contentId}` : `/community/${id}`
    case 'user':
      return `/user/${id}`
    case 'admin_wall_post':
      return `/admin?tab=wall-posts&id=${id}`
    case 'admin_wall_comment':
      return `/admin?tab=wall-comments&id=${id}`
    default:
      return null
  }
}
